<template>
  <div class="app-container">
    <div class="toolbar">
      <el-select
        v-model="filters.state"
        clearable
        placeholder="State"
        size="small"
        @change="loadConversations"
      >
        <el-option v-for="state in states" :key="state" :label="state" :value="state" />
      </el-select>
      <el-button size="small" type="primary" @click="loadConversations">Refresh</el-button>
    </div>

    <el-row :gutter="16">
      <el-col :span="9">
        <el-table :data="conversations" border height="680" @row-click="selectConversation">
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column prop="psid" label="Messenger PSID" min-width="150" />
          <el-table-column prop="state" label="State" width="150" />
          <el-table-column prop="preferredLanguage" label="Lang" width="90" />
          <el-table-column prop="lastMessageText" label="Last Message" min-width="200" />
        </el-table>
      </el-col>

      <el-col :span="15">
        <div v-if="selected" class="detail">
          <div class="detail-header">
            <div>
              <strong>Conversation #{{ selected.id }}</strong>
              <el-tag size="mini" class="state-tag">{{ selected.state }}</el-tag>
            </div>
            <div>
              <el-button size="small" type="warning" @click="setHumanActive"
                >Human Active</el-button
              >
              <el-button size="small" type="success" @click="resumeBot">Resume Bot</el-button>
            </div>
          </div>

          <el-table :data="messages" border height="430">
            <el-table-column prop="direction" label="Direction" width="110" />
            <el-table-column prop="status" label="Status" width="110" />
            <el-table-column prop="language" label="Lang" width="80" />
            <el-table-column prop="inquiryGroupKey" label="Inquiry Group" width="170" />
            <el-table-column prop="attachmentCount" label="Files" width="80" />
            <el-table-column prop="text" label="Text" min-width="360" />
            <el-table-column prop="createTime" label="Created" width="170" />
          </el-table>

          <el-input
            v-model="replyText"
            type="textarea"
            :rows="3"
            placeholder="Manual reply"
            class="reply"
          />
          <el-button size="small" type="primary" :disabled="!replyText" @click="sendReply"
            >Send Manual Reply</el-button
          >
        </div>
        <el-empty v-else description="Select a conversation" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      states: ["BOT_ACTIVE", "HUMAN_REQUESTED", "HUMAN_ACTIVE", "RESOLVED", "BLOCKED"],
      filters: { state: "" },
      conversations: [],
      messages: [],
      selected: null,
      replyText: "",
    };
  },
  created() {
    this.loadConversations();
  },
  methods: {
    async loadConversations() {
      const params = {};
      if (this.filters.state) params.state = this.filters.state;
      const data = await this.axios.get("mall:/api/admin/messenger/conversations", { params });
      this.conversations = data.content || data.items || [];
    },
    async selectConversation(row) {
      this.selected = row;
      const data = await this.axios.get(
        `mall:/api/admin/messenger/conversations/${row.id}/messages`
      );
      this.messages = data.content || data.items || [];
    },
    async setHumanActive() {
      this.selected = await this.axios.post(
        `mall:/api/admin/messenger/conversations/${this.selected.id}/human-active`
      );
      await this.selectConversation(this.selected);
    },
    async resumeBot() {
      this.selected = await this.axios.post(
        `mall:/api/admin/messenger/conversations/${this.selected.id}/resume-bot`
      );
      await this.selectConversation(this.selected);
    },
    async sendReply() {
      await this.axios.post(`mall:/api/admin/messenger/conversations/${this.selected.id}/send`, {
        text: this.replyText,
        idempotencyKey: `admin-${this.selected.id}-${Date.now()}`,
      });
      this.replyText = "";
      await this.selectConversation(this.selected);
    },
  },
};
</script>

<style scoped>
.toolbar {
  margin-bottom: 12px;
}
.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.state-tag {
  margin-left: 8px;
}
.reply {
  margin: 12px 0;
}
</style>
